var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.154 0.639997C16.514 1.31199 16.7921 2.01399 16.9847 2.73599C17.3644 4.09797 17.5501 5.49488 17.5386 6.89596C17.5421 7.80097 17.4647 8.70495 17.3078 9.59982H15.434C15.6105 8.70682 15.697 7.80184 15.6924 6.89596C15.7236 5.20898 15.4109 3.52907 14.7693 1.93599C14.6978 1.76399 14.6217 1.59799 14.542 1.43999C14.1036 0.569008 13.1136 0.00399358 12.0174 0H11.9828C10.8867 0.00399998 9.89665 0.569008 9.45818 1.43999C9.37856 1.59799 9.30241 1.76398 9.23087 1.93599C8.58933 3.52899 8.27663 5.20893 8.3078 6.89596C8.30318 7.80197 8.38972 8.70695 8.56626 9.59982H6.6924C6.53547 8.70482 6.45817 7.80084 6.46163 6.89596C6.45009 5.49496 6.63586 4.0979 7.01547 2.73599C7.20816 2.01399 7.48626 1.31199 7.84624 0.639997C5.54431 1.37799 3.55962 2.70798 2.15654 4.4531C0.753467 6.19808 0.001152 8.27311 0 10.3999V10.6719L6.46154 17.8719V24H17.5385V17.8719L24 10.6719V10.3999C23.9988 8.27295 23.2465 6.19798 21.8435 4.4531C20.4404 2.70811 18.4559 1.37804 16.154 0.639997ZM16.1632 16.7999H12.9231V20.7999H11.077V16.7999H7.83691L2.80621 11.1999H11.077V16.7999H12.9231V11.1999H21.1939L16.1632 16.7999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdrop);
export default __webpack_public_path__ + "static/media/airdrop.19c6fa45f9f8ff93a70c5088d36beae5.svg";
export { ForwardRef as ReactComponent };